import Box from '@mui/material/Box';
import type { FC} from 'react';
import { useCallback, type JSX } from 'react';
import { useAppSelector } from '@/store/hooks/redux';
import CreativeTypesEnum from '../../shared/constants/creatives-types.enum';
import MediaLibraryImages from './images/MediaLibraryImages';
import MediaLibraryVideosWrapper from './videos/MediaLibraryVideosWrapper';
import { AvailablePlatformsEnum } from '@/editor/shared/constants/available-platforms';

const MediaLibraryWrapper: FC = (): JSX.Element => {
  const drawerState = useAppSelector((state) => state.editorModalsDrawersReducer.mediaLibraryDrawerState);

  const resolveComponent = useCallback(() => {
    const { creativeType, platform } = drawerState;
    const key = `${creativeType}_${platform}`;
    switch (key) {
      case `${CreativeTypesEnum.VIDEO}_${AvailablePlatformsEnum.BIDTHEATRE}`:
        return (
          <>
            <MediaLibraryVideosWrapper />
            <MediaLibraryImages />
          </>
        );

      case `${CreativeTypesEnum.VIDEO}_${AvailablePlatformsEnum.META}`:
        return <MediaLibraryVideosWrapper />;

      case `${CreativeTypesEnum.CAROUSEL}_${platform}`:
      case `${CreativeTypesEnum.DYNAMIC}_${platform}`:
      case `${CreativeTypesEnum.SINGLE}_${platform}`:
        return <MediaLibraryImages />;

      default:
        return null;
    }
  }, [drawerState]);

  return <Box>{resolveComponent()}</Box>;
};

export default MediaLibraryWrapper;
